<mbs-modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'wizards:entityWizards.company.templatesStep.destinationSettings.title' | i18next">
  <ng-container modal-body>
    @if (ready()) {
      <mbs-destination-plus-retention-step
        [advancedOptionsAvailable]="advancedOptionsAvailable()"
        [advancedOptionsTitle]="advancedOptionsTitle"
        [advancedOptionsValid]="advancedOptions()?.valid"
        [canAddStorageAccount]="false"
        [Storages]="storages()"
        [(ngModel)]="destinationPlusRetention"
        (advancedOptionsOpened)="advancedOptionsOpenedHandler($event)"
        (changeStorage)="changeStorageHandler($event)">
        <mbs-advanced-options-step
          [advancedOptionsFlags]="advancedOptionsFlags()"
          [(ngModel)]="advancedOptions"
          (changeStorageType)="changeStorageTypeHandler($event)"></mbs-advanced-options-step>
      </mbs-destination-plus-retention-step>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
